import * as Sentry from '@sentry/browser'

if process.env.NODE_ENV is 'production'
  Sentry.init({
    dsn: "https://3a4b52179fdd46f7bd82c957235b1411@o236567.ingest.sentry.io/5193736"
  })

# Need this for uncaught exceptions from:
#   - Event handlers
#   - async code
#   - Exceptions occurring outside the scope of our root <App> component
window.onerror = (message, source, lineno, colno, error) ->
  return unless error?
  dispatchErrorReport(error, { message, source, lineno, colno })

export setErrorContext = ({ user, project }) ->
  Sentry.configureScope((scope) ->
    scope.setUser(user);
    scope.setTag("project", project);
  )

export dispatchErrorReport = (error, info) ->
  Sentry.withScope((scope) ->
    _.map(scope, (val, key) ->
      scope.setExtra(key, val)
    )
    Sentry.captureException(error, info)
  )

window.dispatchErrorReport = dispatchErrorReport